import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import DecodingModel from "../models/DecodingModel.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class SoundYLongEMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 10;
        this.markHeight = 10;
        this.padding = this.adjustToScale(10);
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
            this.markX = this.targetTextField.width/2;
            this.markY = this.targetTextField.height/2 + (this.adjustToScale(-90)*this.multipleOfDefaultFontSize);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const markXOffset: number = 4;
        const markYOffset: number = -24;

        let mark = new Container();

        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 100,
            fill: color,
            align: 'center'
        });

        const eText = new Text({text:"e", style:style});
        this.markWidth = eText.width;

        const grWidth = this.markWidth - this.padding * 2;
        let gr = new Graphics();
        gr.moveTo(markXOffset, markYOffset + this.strokeThickness / 2);
        gr.lineTo(markXOffset + grWidth, markYOffset + this.strokeThickness / 2);
        gr.stroke({width:this.strokeThickness, color:color, cap:"round"});
        gr.pivot.set(gr.width/2, gr.height/2);
        mark.addChild(gr);

        const letter = new Text({text:"e", style:style});
        letter.anchor.set(0.5);
        mark.addChild(letter);

        if(this.targetTextField)
        {
            this.markX = this.targetTextField.width-markXOffset*2;
        }

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}